import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-google-map-custom-icon",
  templateUrl: "./google-map-custom-icon.component.html",
  styleUrls: ["./google-map-custom-icon.component.scss"],
  standalone: false,
})
export class GoogleMapCustomIconComponent implements OnInit {
  @Input() property: any;
  @ViewChild("iconElement") iconElement!: ElementRef;

  constructor() {}

  getIconPath(type: string): string {
    switch (type) {
      case "starting_point":
        return "assets/icon/map-icons/marker-start.svg";
      case "point_of_arrival":
        return "assets/icon/map-icons/marker-end.svg";
      default:
        return "assets/icon/map-icons/marker.svg";
    }
  }

  ngOnInit() {}
  toggleHighlight() {
    const markerView = this.iconElement.nativeElement;
    if (markerView.classList.contains("highlight")) {
      markerView.classList.remove("highlight");
      markerView.zIndex = null;
    } else {
      markerView.classList.add("highlight");
      markerView.zIndex = 99;
    }
  }
}
